import React from 'react';

import { Box, Skeleton } from '@chakra-ui/react';
import { MetricCards } from 'Deer/metricCards/MetricCards';
import { MODULE_KEYS_METRIC_CARDS_DEER } from 'Deer/metricCards/constants';

import { isMobileView } from 'constants/isMobileView';

interface Props {
  cardKPIData: Array<{
    title: string;
    value: number;
  }>;
  showMetrics: boolean;
  isLoading: boolean;
  gridStatePersistenceKey?: string;
}

const GroupByGoalMetricsCards = ({ cardKPIData, showMetrics, isLoading, gridStatePersistenceKey }: Props) => {
  if (isLoading) {
    return (
      <Box display="flex">
        <Skeleton height="100px" width="100%" borderRadius="8px" startColor="surface.F5F5F5" endColor="surface.g3" />
      </Box>
    );
  }
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {!isMobileView() && cardKPIData && showMetrics && (
        <MetricCards
          height="100%"
          columns="repeat(4, 1fr)"
          cardTitle="Metrics"
          cards={cardKPIData}
          module={MODULE_KEYS_METRIC_CARDS_DEER.GOAL}
          gridStatePersistenceKey={gridStatePersistenceKey}
        />
      )}
    </>
  );
};

export { GroupByGoalMetricsCards };
